import jwt_decode from "jwt-decode";
import axios from "axios";
import API_ROUTES from "../constants/apis";

export function setAuthTokens(accessToken, refreshToken) {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
}

export const getAccessToken = () => {
  return localStorage.getItem("accessToken");
};

export function getRefreshToken() {
  return localStorage.getItem("refreshToken");
}

export function removeAuthTokens() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
}

export function logoutUser() {
  removeAuthTokens();
}

export function isAccessTokenExpired() {
  const accessToken = getAccessToken();

  if (!accessToken) {
    return true;
  }

  const decodedToken = jwt_decode(accessToken);

  const currentTime = Math.floor(Date.now() / 1000);
  return currentTime >= decodedToken.exp;
}

export async function renewAccessToken() {
  const refreshToken = getRefreshToken();

  try {
    const response = await axios.post(API_ROUTES.REFRESH, {
      refresh: refreshToken,
    });

    if (response.data && response.data.access) {
      removeAuthTokens();

      const accessToken = response.data.access;
      const refreshToken = response.data.refresh;

      setAuthTokens(accessToken, refreshToken);
    } else {
      console.error("Token renewal failed: Invalid response data");
      logoutUser();
    }
  } catch (error) {
    console.error("Token renewal failed:", error.message);
    // logoutUser();
  }
}

export const isUserLoggedIn = () => {
  const token = getAccessToken();

  if (!token) {
    return false;
  }

  const decodedToken = jwt_decode(token);

  const authenticated = decodedToken;
  return authenticated;
};
